// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/auth.login/LoginForm.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/auth.login/LoginForm.tsx");
  import.meta.hot.lastModified = "1767577328000";
}
// REMIX HMR END

import { Checkbox, Collapse, FormControlLabel, IconButton, Typography } from '@mui/material';
import Alert from '~/components/Alert/Alert';
import { Close, ErrorOutline } from '@mui/icons-material';
import { useEffect, useState } from 'react';
export default function LoginForm({
  actionData
}) {
  _s();
  const [form, setForm] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [alertProps, setAlertProps] = useState({
    isShow: false,
    message: '',
    type: undefined
  });
  const [fieldType, setFieldType] = useState('password');
  const onChangeHandler = (e, type) => {
    const value = type === 'rememberMe' ? e.currentTarget.checked : e.currentTarget.value;
    setForm(prevState => {
      return {
        ...prevState,
        [type]: value
      };
    });
  };
  const onAlertHandler = () => {
    setAlertProps(prevState => {
      return {
        ...prevState,
        isShow: false,
        message: ''
      };
    });
  };
  const onClickIconPassword = e => {
    e.preventDefault();
    if (fieldType === 'password') {
      setFieldType('text');
    } else {
      setFieldType('password');
    }
  };
  useEffect(() => {
    const {
      message,
      type
    } = actionData?.status || {};
    setAlertProps(prevState => {
      return {
        ...prevState,
        isShow: !!message,
        message: message,
        type: type
      };
    });
  }, [actionData]);
  const {
    email,
    password,
    rememberMe
  } = form;
  const {
    isShow,
    message,
    type
  } = alertProps;
  return <div className="wrapper relative block min-h-[217px] w-[452px] bg-doctor p-[50px] rounded-[8px] [box-shadow:24px_24px_48px_5px_rgba(0,_0,_0,_0.05)]">
      <h5 className="header relative block text-umbra font-bold text-[32px] text-left mb-[12px]">
        Login to your account
      </h5>
      <h6 className="subheader relative block text-left text-[16px] text-trolleygrey mb-[30px] font-normal">
        Fill in your account details to sign in
      </h6>

      <div className="mb-6">
        <Collapse in={alertProps.isShow}>
          <Alert variant="filled" severity={type} className="h-auto" action={<IconButton aria-label="close" color="inherit" size="small" onClick={onAlertHandler}>
                <Close className="!text-white" fontSize="inherit" />
              </IconButton>}>
            {isShow && type === 'warning' && 'There are items that require your attention'}

            {isShow && type === 'error' && message}
          </Alert>
        </Collapse>
      </div>

      <form method="post">
        <div className="container-email relative flex flex-col mb-[17px]">
          <label htmlFor="email" className="label-email relative block mb-[6px] text-[16px] font-semibold text-umbra">
            Email
          </label>
          <div className="input-email-container relative block w-full">
            <input type="text" name="email" className={`input-email relative block w-full p-[12px] !pr-[48px] rounded-[4px] border-primarylight border-[1px] border-[solid] ${isShow && type === 'warning' ? 'border-[2px] border-[solid] border-rosysunset' : ''}`} placeholder="Email" onChange={e => onChangeHandler(e, 'email')} value={email}></input>
            <i className="icon-email absolute right-0 top-2/4 -translate-y-1/2 bg-[url('/assets/images/login/email.svg')] bg-no-repeat [background-size:24px] bg-center w-[24px] h-[24px] mr-[12px]"></i>
          </div>
          {isShow && type === 'warning' && <div className="warning-alert relative flex items-center mt-[4px]">
              <ErrorOutline color="error"></ErrorOutline>
              <p className="text-message relative block text-umbra text-[14px] ml-[8px]">
                {message}
              </p>
            </div>}
        </div>
        <div className="container-password relative flex flex-col">
          <label htmlFor="password" className="label-password relative block mb-[6px] text-[16px] font-semibold text-umbra">
            Password
          </label>
          <div className="input-password-container relative block w-full">
            <input type={fieldType} name="password" className="input-password relative block w-full p-[12px] !pr-[48px] rounded-[4px] border-primarylight border-[1px] border-[solid]" placeholder="Password" onChange={e => onChangeHandler(e, 'password')} value={password}></input>
            <button className="icon-password absolute right-0 top-2/4 -translate-y-1/2 bg-[url('/assets/images/login/password.svg')] bg-no-repeat [background-size:24px] bg-center w-[24px] h-[24px] mr-[12px]" onClick={onClickIconPassword} type="button"></button>
          </div>
        </div>
        <button className="button-signin relative flex items-center justify-center w-full px-0 py-[14px] mt-[22px] bg-bluelight rounded-[4px] text-[14px] font-normal text-doctor mb-[36px]" type="submit">
          Sign In
          <i className="button-icon bg-[url('/assets/images/login/sign-in.svg')] relative block [background-size:20px] w-[20px] h-[20px] bg-no-repeat ml-[10px]"></i>
        </button>
        <div className="container-link relative flex justify-between items-center">
          <FormControlLabel control={<Checkbox name="rememberMe" value={rememberMe} onChange={e => onChangeHandler(e, 'rememberMe')} checked={rememberMe} />} label={<Typography variant="body1" component="p" className="text-[#828282] font-semibold">
                Remember me
              </Typography>} />
          {/* @TODO: enable this link when the recover account page is ready */}
          {/* <Link
                      className="forgot-password text-bluelight font-semibold text-[14px]"
                      to={'/auth/recover-account'}
                    >
                      Forgot Password?
                    </Link> */}
        </div>
      </form>
    </div>;
}
_s(LoginForm, "m31eYGtKGPfbLt0QvsADHySdzxw=");
_c = LoginForm;
var _c;
$RefreshReg$(_c, "LoginForm");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;